export const changeWebsiteTitle = (isRtl: boolean) => {
  if (isRtl) document.title = 'رابطة الطلّاب المسلمين في لبنان'
  else document.title = 'Muslim Student League In Lebanon'
}
